import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {httpi,baseURL} from './http'
import waterfall from 'vue-waterfall2'
//import 'fullpage.js/vendors/scrolloverflow';
import VueFullpage from 'vue-fullpage.js'
import animate from 'animate.css'

// 引入 vue-awesome-swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
 
//引入 vue-awesome-swiper 样式
import 'swiper/dist/css/swiper.css'

Vue.config.productionTip = false
Vue.prototype.$httpi = httpi;
Vue.prototype.$baseURL = baseURL;

Vue.use(VueFullpage)
Vue.use(waterfall)
Vue.use(animate)
Vue.use(VueAwesomeSwiper)

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
